/*global jQuery,document,WebFont*/
jQuery(document).ready(function ($) {
	"use strict";

	WebFont.load({
		typekit: {
			id: 'xky3nnq'
		},
		timeout: 1500
	});

	// Mobile menu toggle
	$('.menu-toggle').click(function () {
		$('html').toggleClass('menu-open');
		$('nav').toggleClass('open');
	});

	// Sub-menu toggle
	$('.menu li.menu-item-has-children > a').click(function (e) {
		e.preventDefault();

		$('.menu li.menu-item-has-children .sub-menu').not($(this).next('.sub-menu')).removeClass('open').slideUp(200);

		$(this).next('.sub-menu').toggleClass('open').slideToggle();
	});

//	var Slideshow = (function() {
//		this.$slideshow = null;
//
//		var classes = {
//			animateOut: 'animate-out',
//			allSlides: 'slick-slide',
//			currentSlide: 'slick-current',
//		};
//
//		function slideshow(el, args) {
//			this.$slideshow = $(el);
//
//			this.settings = {
//				accessibility: true,
//				autoplay: true,
//				autoplaySpeed: 3000,
//				draggable: false,
//				fade: true,
//				speed: 1500,
//				pauseOnHover: false
//			}
//
//			this.$slideshow.on('init', function (event, obj) {});
//			this.$slideshow.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
//				var $slider = slick.$slider;
//				var $currentSlide = $slider.find('.slick-current').addClass('animate-out');
//			});
//			this.$slideshow.on('afterChange', function (event, slick, currentSlide) {
//				var $slider = slick.$slider;
//				var $allSlides = $slider.find('.slick-slide').removeClass('animate-out');
//			});
//
//			this.$slideshow.slick(this.settings);
//		}
//
//		return slideshow;
//	})(),
//	var mySlideshow = new Slideshow();
//	mySlideshow.$slideshow = $('.site-hero');

	

	//	Home slider
	(function homeSlider() {
		var $siteHero = $('.site-hero');

		$siteHero
			.on('init', function (event, obj) {
			})
			.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
				var $slider = slick.$slider;
				var $currentSlide = $slider.find('.slick-current').addClass('animate-out');
			})
			.on('afterChange', function (event, slick, currentSlide) {
				var $slider = slick.$slider;
				var $allSlides = $slider.find('.slick-slide').removeClass('animate-out');
			});

		$siteHero.slick({
	//		accessibility: true,
			autoplay: true,
			autoplaySpeed: 3000,
	//		dots: true,
			draggable: false,
			fade: true,
			speed: 1500,
			pauseOnHover: false
		});
	})();

	// Prevent default on '#' anchors
//	$('a[href="#"]').on('click', function (e) {
//		e.preventDefault();
//	});

	// Modal Popup
	if ($(".staff-modal")[0]) {
		$(document.body).append("<section id='modal-box' style='display: none;'></section>");
	}
	$('#modal-box').click(function () {
//		if (e.target !== this) {
//			return;
//		}
		$(this).fadeOut();
		$('html').removeClass('no-scroll');
	});
	$('a.staff').click(function (e) {
		e.preventDefault();
		var staffID = $(this).attr('data-id'),
			staffContent = $('div#' + staffID).html();
		$('html').addClass('no-scroll');
		$('#modal-box').html(staffContent).fadeIn();
	});

	// Animations
	$('.animate-on-scroll').waypoint({
		handler: function () {
			$(this.element).addClass('animate');
		},
		offset: '100%'
	});
	$('.animate-on-load').addClass('animate');

	// Search Form submit
	$('.search-field').keydown(function (e) {
		// enter has keyCode = 13, change it if you want to use another button
		if (e.keyCode === 13) {
			this.form.submit();
			return false;
		}
	});
});